import WithdrawCentral from './WithdrawCentral'

export default WithdrawCentral
